var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":_vm.$t('CardTitle'),"collapse-action":""}},[_c('gs-pie-chart',{attrs:{"series-info":_vm.feedbackPieSeriesInfo,"series-data":_vm.seriesData,"no-data-title":_vm.$t('NoData.Title'),"no-data-subtitle":_vm.$t('$NoData.Subtitle')},on:{"chart-data":(data) => this.$emit('chart-data', data)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }